import { gql } from '@apollo/client';

export const addDemographicAudienceInsightMutation = gql`
  mutation addCustomDemographicInsight(
    $contactProperty: String!
    $presentationMode: DemographicInsightPresentationMode!
  ) {
    addDemographicAudienceInsight(
      contactProperty: $contactProperty
      presentationMode: $presentationMode
    ) {
      success
      ... on DemographicInsightContactPropertyLengthFailure {
        maxLength
      }
      ... on DemographicInsightLimitExceededFailure {
        maxDemographicInsights
      }
    }
  }
`;

export const removeDemographicAudienceInsightMutation = gql`
  mutation removeCustomDemographicInsight($contactProperty: String!) {
    removeDemographicAudienceInsight(contactProperty: $contactProperty) {
      success
    }
  }
`;

export const addBehavioralAudienceInsightMutation = gql`
  mutation addCustomBehavioralInsight(
    $eventName: String!
    $presentationMode: BehavioralInsightPresentationMode!
    $dataType: ClientDataType!
  ) {
    addBehavioralAudienceInsight(
      eventName: $eventName
      presentationMode: $presentationMode
      dataType: $dataType
    ) {
      success
      ... on BehavioralInsightEventNameLengthFailure {
        maxLength
      }
      ... on BehavioralInsightLimitExceededFailure {
        maxBehavioralInsights
      }
    }
  }
`;

export const removeBehavioralAudienceInsightMutation = gql`
  mutation removeCustomBehavioralInsight($eventName: String!, $dataType: ClientDataType!) {
    removeBehavioralAudienceInsight(eventName: $eventName, dataType: $dataType) {
      success
    }
  }
`;
